export default __webpack_public_path__ + "static/fin-ins-block-claims-5b1f5bce905d3e05f9823542a259ce94.png";